import angular from 'angular';
import Model from './model';

import AnalyticsServ from '../services/analytics';

function MemberFactory(Model, AnalyticsServ) {
  return class MemberModel extends Model {
    constructor(data = {}) {
      super(data);
      this.setApi('/customer/user/:memberId', {
        memberId: '@id'
      }, {
        add: {
          method: 'POST',
          isArray: true,
          params: {
            newUser: () => this.getData().newUser || false
          },
          success: [
            data => this.setData(data),
            () => AnalyticsServ.added('Member')
          ],
          fail: [r => {
            if (r.status === 404) {
              this.data.newUser = true;
              this.error = {};
            } else {
              this.fail(r);
            }
          }]
        },
        update: {
          method: 'PUT',
          isArray: true,
          success: [
            () => this.setData(),
            () => AnalyticsServ.updated('Member')
          ],
        },
        remove: {
          method: 'DELETE',
          isArray: true,
          success: [
            () => this.setData(),
            () => AnalyticsServ.removed('Member')
          ],
        }
      });
    }
  }
}

MemberFactory.$inject = ['Model', 'AnalyticsServ'];

export default angular.module('models.member', [Model, AnalyticsServ])
  .factory('Member', MemberFactory)
  .name;



// WEBPACK FOOTER //
// ./project/models/member.js